import styled, { css, keyframes } from 'styled-components';

import { forMd } from '../../../config/_variables';
import BlackFridayDiamondImage from '../../../assets/diamond-black-friday.png';

const BannerPulseOrange = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(242, 101, 38, 0.7);
    transform: scale(0.5);
  }

  70% {
    box-shadow: 0 0 0 10px rgba(242, 101, 38, 0);
    transform: scale(1.1);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(242, 101, 38, 0);
    transform: scale(1.1);
  }
`;

export const BannerWrapper = styled.div`
  align-items: center;
  background: radial-gradient(82.85% 39.04% at 50% 17.09%, #782A07 0%, #000 100%);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: flex-start;
  overflow: hidden;
  padding: 32px 16px;
  width: 100%;
  position: relative;

  ${forMd} {
    flex-direction: row;
    gap: 50px;
    height: 160px;
    justify-content: flex-start;
    margin-bottom: 24px;
    padding: 0;
    width: 948px;
    background: radial-gradient( ellipse 28% 94% at 17% 50%,#782a07 11%,#111111 86% );
  }
`;

export const BannerImage = styled.img`
  width: 220px;
`;

export const ContainerTexts = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column; 
  gap: 16px;

  ${forMd} {
    align-items: flex-start;
    gap: 8px;
  }
`;

export const Title = styled.h1`
  color: #FFFFFF;
  font-size: 21px;
  font-weight: 700;
  font-family: 'Poppins';
  line-height: 1.4;
  display: flex;
  flex-direction: column;
  align-items: center;

  br {
    display: none;
  }

  span {
    color: #F26526;
  }

  ${forMd} {
    align-items: flex-start;
    line-height: 1.2;
    font-size: 24px;
  }
`;

export const Disclaimer = styled.h2`
  color: #FFFFFF;
  font-size: 13px;
  font-weight: 500;
  font-family: 'Poppins';
  line-height: 1.4;
  position: relative;
  max-width: 250px;
  text-align: center;


  span {
    color: #F8AB00;
    font-weight: 700;
  }

  :after {
    content: "";
    display: block;
    background: url(${BlackFridayDiamondImage}) no-repeat center center;
    width: 15px;
    height: 18px;
    position: absolute;
    top: -2px;
    left: 0;
    background-size: contain;
  }

  ${forMd} {
    max-width: unset;
    text-align: left;
    padding-left: 8px;
    line-height: 1.2;
    font-size: 15px;
  }
`;

export const ImageContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  position: relative;
  width: 295px;

  ${forMd} {
    margin-left: 40px;
    height: 100%;
  }
`;

export const AnimationContainer = styled.div`
  height: 100%;
  left: 0;
  overflow: hidden;
  position: absolute;
  top: 0;
  width: 100%;
`;

export const AnimationCircle = styled.div`
  background: transparent;
  border-radius: 50%;
  box-shadow: 0 0 0 16px rgba(242, 101, 38, .1);
  height: 212px;
  left: calc(50% - 114px);
  position: absolute;
  top: calc(50% - 114px);
  width: 212px;
  display: none;

  ${forMd} {
    display: initial;
  }

  ${({ withAnimation }) => withAnimation ? css`
    animation: ${BannerPulseOrange} 2s infinite;
    transform: scale(0);
  ` : css`
    scale: 1.13;
    border: 1px solid #F26526;
  `}
`;

export const BorderBlackFriday = styled.img`
  position: absolute;
  bottom: 0;
  right: 0;
  display: none;

  ${forMd} {
    display: block;
  }
`;